import { Box, font, preventOneWordInLastLine, themedColor } from '@lemonade-hq/cdk';
import { Button, MEDIA_QUERIES } from '@lemonade-hq/nuis';
import { useNavContext } from '@lemonade-hq/nuiza';
import type React from 'react';
import styled from 'styled-components';

const StyledContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;

  ${MEDIA_QUERIES.mobile`
        max-width: 320px;
    `}

  ${MEDIA_QUERIES.tabletAndDesktop`
        max-width: 850px;
    `}
`;

const StyledTitle = styled.h3`
  color: ${themedColor('night')};

  ${MEDIA_QUERIES.mobile`
        letter-spacing: -2px;
        ${font('main', {
          fontSize: '56px',
          lineHeight: '50px',
          fontWeight: 800,
        })};
    `}

  ${MEDIA_QUERIES.tabletAndDesktop`
        padding: 0 16px;
        letter-spacing: -4px;
        ${font('main', {
          fontSize: '78px',
          lineHeight: '87px',
          fontWeight: 800,
        })};
    `}
`;

const StyledSubTitle = styled.h4`
  color: ${themedColor('grayNight')};

  ${font('main', { fontSize: '20px', lineHeight: '28px', fontWeight: 400 })};

  ${MEDIA_QUERIES.mobile`
        margin-top: 22px;
        margin-bottom: 36px;
    `}

  ${MEDIA_QUERIES.tabletAndDesktop`
        margin-top: 27px;
        margin-bottom: 56px;
    `}
`;

const StyledButton = styled(Button)`
  width: fit-content;
  padding-left: 35px;
  padding-right: 35px;
  margin: 0 auto;
  pointer-events: auto;
  &:hover {
    text-decoration: none;
  }
`;

const TITLE = 'As our community grows, so does our impact';
const SUB_TITLE = 'Help support causes you care about, simply by getting a Lemonade policy';
const CTA_TEXT = ' Join the Lemonade Giveback';
const Giveback2022Footer: React.FC = () => {
  const { nav } = useNavContext();

  return (
    <StyledContainer mt={[60, 100, 170]} mb={[70, 120, 180]}>
      <StyledTitle
        // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
        dangerouslySetInnerHTML={{ __html: preventOneWordInLastLine(TITLE) }}
      />
      <StyledSubTitle
        // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
        dangerouslySetInnerHTML={{
          __html: preventOneWordInLastLine(SUB_TITLE),
        }}
      />
      {/* @ts-expect-error - styled components type issue */}
      <StyledButton as="a" flavor="primary" href={nav.giveback} glowing size="big">
        {CTA_TEXT}
      </StyledButton>
    </StyledContainer>
  );
};

export default Giveback2022Footer;
